import { QuestionTypePage } from './QuestionTypePage';
export default QuestionTypePage;
